import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { SafetyBanner } from './SafetyBanner';
import { RangeHours } from './RangeHours';
import { NRASafetyRules } from './NRASafetyRules';
import { GeneralRangeRules } from './GeneralRangeRules';
import { IndoorRangeRules } from './IndoorRangeRules';
import { OutdoorRangeRules } from './OutdoorRangeRules';
import { SportingClaysArchery } from './SportingClaysArchery';
import { ImportantPhoneNumbers } from './ImportantPhoneNumbers';
import { CalendarReminder } from './CalendarReminder';
import { QuickLinks } from './QuickLinks';
export function RangeRulesPage() {
  return <PageLayout data-id="element-2878">
      <HeaderBanner data-id="element-2879" />
      <SafetyBanner data-id="element-2880" />
      <RangeHours data-id="element-2881" />
      <NRASafetyRules data-id="element-2882" />
      <GeneralRangeRules data-id="element-2883" />
      <IndoorRangeRules data-id="element-2884" />
      <OutdoorRangeRules data-id="element-2885" />
      <SportingClaysArchery data-id="element-2886" />
      <ImportantPhoneNumbers data-id="element-2887" />
      <CalendarReminder data-id="element-2888" />
      <QuickLinks data-id="element-2889" />
    </PageLayout>;
}